module.exports = __webpack_public_path__ + "img/personalizacoes.b6a1a90f.svg";